import React from 'react'

import { Grid } from '@mui/material'
import { TextField } from '@front/squirtle'

const SearchForm = props =>
  <Grid container>
    <Grid hidden size="grow">
      <TextField name='test' />
    </Grid>
  </Grid>

export default React.memo(SearchForm)
